import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { container } from "tsyringe";
import DefaultLink from "assets/images/default-link.png";
import OpenGraphApi from "api/clapaction/OpenGraphApi";
import OpenGraphMedataResponseResource from "common/resources/OpenGraph/OpenGraphMetadataResponseResource";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import MediaService from "services/projects/MediaService";
import { translateISO369 } from "utils/I18nText";

type IProps = {
	media: MediaResponseResource;
	onOpen: (mediaResponseResource: MediaResponseResource) => void;
};

const openGraphApi = container.resolve(OpenGraphApi);
const mediaService = container.resolve(MediaService);

export default function LinkMediaCard(props: IProps) {
	const [image, setImage] = useState<string | null>(null);
	const { openGraphMetadata } = useOpenGraphMetadata(props.media.url ?? "");

	useEffect(() => {
		if (!props.media.previewImage) return;
		mediaService.downloadPreviewImage(props.media.project.id, props.media.id).then((res) => {
			setImage(URL.createObjectURL(res));
		});
	}, [props]);

	return (
		<div className={classes["root"]}>
			{props.media.url && (
				<Link to={props.media.url} target="_blank" className={classes["media-container"]}>
					{image ? (
						<LazyImage src={image} alt={"URL preview"} className={classes["media-preview"]} />
					) : openGraphMetadata?.image ? (
						<LazyImage src={openGraphMetadata.image} alt={"URL preview"} className={classes["media-preview"]} />
					) : (
						<LazyImage src={DefaultLink} alt={"No URL preview"} />
					)}
				</Link>
			)}

			{props.media.caption && (
				<Typography type="p" weight="bold" className={classes["title"]}>
					{translateISO369(props.media.caption)}
				</Typography>
			)}
		</div>
	);
}

const useOpenGraphMetadata = (url: string) => {
	const [openGraphMetadata, setOpenGraphMetadata] = useState<OpenGraphMedataResponseResource | null>(null);

	useEffect(() => {
		const fetchPreviewData = async () => {
			openGraphApi
				.getMetadata(url)
				.then(setOpenGraphMetadata)
				.catch((e) => console.error("Error fetching link preview data for", url, e));
		};

		fetchPreviewData();
	}, [url]);

	return { openGraphMetadata };
};
